import { Button, Flex, Form, Input, InputNumber, Switch } from "antd";
import { useEffect } from "react";

const IotGateWayComponentForm = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.editData) {
      form.setFieldsValue({
        ...props.editData,
      });
    } else {
      form.resetFields();
    }
  }, [props.editData, form]);

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      style={{ maxWidth: 600 }}
      onFinish={(data) =>
        props.saveData({ ...props.editData, ...data }).then((success) => {
          if (success) {
            form.resetFields();
          }
        })
      }
    >
      <Form.Item
        label="Broker Name"
        name="brokerName"
        rules={[{ required: true, message: "Please input broker name!" }]}
      >
        <Input placeholder="Enter broker name" />
      </Form.Item>

      <Form.Item
        label="Broker URL"
        name="brokerUrl"
        rules={[
          { required: true, message: "Please input MQTT broker URL!" },
          { type: "url", message: "Please enter a valid URL!" }, // optional: validates URL format
        ]}
      >
        <Input
          placeholder="Enter MQTT broker URL (e.g., tcp://broker.hivemq.com:1883)"
          allowClear
        />
      </Form.Item>
      <Form.Item
        label="Server Port"
        name="serverPort"
        rules={[
          { required: true, message: "Please input Server port!" },
          {
            type: "number",
            min: 1,
            max: 65535,
            message: "Port must be between 1 and 65535",
          },
        ]}
      >
        <InputNumber
          placeholder="Enter port number (e.g., 1883)"
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item
        label="Client ID"
        name="clientId"
        rules={[{ required: true, message: "Please input Client ID!" }]}
      >
        <Input placeholder="Enter MQTT Client ID" allowClear />
      </Form.Item>
      <Form.Item
        label="Username"
        name="username"
        // rules={[{ required: true, message: "Please input Username!" }]}
      >
        <Input placeholder="Enter Username" allowClear />
      </Form.Item>
      <Form.Item
        label="Password"
        name="password"
        // rules={[{ required: true, message: "Please input Password!" }]}
      >
        <Input.Password placeholder="Enter Password" allowClear />
      </Form.Item>
      <Form.Item
        label="Subscription Topic"
        name="subTopicName"
        rules={[
          { required: true, message: "Please input subscription topic!" },
        ]}
      >
        <Input placeholder="Enter subscription" />
      </Form.Item>
      <Form.Item label="Publish Topic" name="pubTopicName">
        <Input placeholder="Enter publish topic" />
      </Form.Item>
      {/* <Form.Item label="Status" name="status" valuePropName="checked">
        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
      </Form.Item> */}
      <Flex justify="end">
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Flex>
    </Form>
  );
};

export default IotGateWayComponentForm;
